'use strict';

const isNode = typeof document === 'undefined';

const _ = require('lodash');
const Classnames = require('classnames');
const React = require('react');
const LinkedStateMixin = require('react-addons-linked-state-mixin');

const ReactRouter = require('react-router');
const Link = ReactRouter.Link;

const Components = require('../../components');
const Constants = require('../../constants');
const Global = require('../../global');
const Moma = require('../../plugins/moma/');
const {Lightbox, Lightboxes, addImage } = require('../../components/lightbox');

const Media = Components.Media;
const ResponsiveMixin = Global.ResponsiveMixin;

const SeriesItems = React.createClass({
    mixins: [ ResponsiveMixin ],

    render: function() {
        const items = this.props.items;
        if (!items || items.length == 1)  // SeriesItem gallery shows current item so if length == 1 then there are no other products
            return null;

        const gallerySpec = {
            desktop: {
                position: 'outside',
                graphic: 'mid',
                navigation: 'paged',
            },
            mobile: {
                position: 'outside',
                graphic: 'mid',
                navigation: 'paged',
            },
        };
        return (
            <div className='co-item-gallery co-item-series'>
                <div className='co-item-gallery-label'>
                    ALSO IN THIS SERIES
                </div>
                <SeriesItemGallery gallery    = {items}
                                   spec       = {gallerySpec}
                                   scrolltime = {400}
                                   pageSize   = {0.7}
                                   index       = {this.props.index}
                                   ident      = 'series' />
                <Lightboxes />
            </div>
        );
    }
});

var SeriesItemGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            desktop: {
                width: Constants.Breaks.DesktopWidth,
                height: 138,
            },
            mobile: {
                portrait: {
                    width: 500,
                    height: 138,
                },
                landscape: {
                    width: 750,
                    height: 138,
                },
            },
        };
    },
    slideContent: function(slide, meta) {
        const height = meta ? meta.height : null;
        const width = meta ? meta.width : null;
        return (
            <div>
                <Link to={slide.url} state={{ scroll: this.state.viewportLayout != 'desktop' }} onClick={()=>console.log(slide.filename)}>
                    <Media media={slide} width={width} height={height} />
                </Link>
            </div>
        );
    },
});

module.exports = SeriesItems;



// WEBPACK FOOTER //
// ./src/collections/product/series-items.jsx